import { mapGetters, mapState } from "vuex";
import { isEmpty as _isEmpty } from "lodash";
import "JS/helpers/customEventPolyfill";
import STATE from "Constants/campaign/civicactioncenter/state";

function dispatch(type, payload) {
  const event = new CustomEvent(type, {
    bubbles: true,
    detail: payload
  });
  document.dispatchEvent(event);
}

export default {
  computed: {
    ...mapGetters(STATE.SCOPE_CAC, {
      advocateRecord: STATE.HAS_ADVOCATE,
      hasAdvocate: STATE.HAS_ADVOCATE,
      formErrorMessage: STATE.VALIDATION_ERROR_MSG
    }),
    ...mapGetters(STATE.SCOPE_FORMS, {
      formError: STATE.ERROR,
      formValid: STATE.FORM_VALID
    }),
    ...mapState(STATE.SCOPE_CAC, {
      registrationCompleted: STATE.REGISTRATION_COMPLETED,
      voterInformation: STATE.VOTER_INFORMATION
    }),
    ...mapState(STATE.SCOPE_FORMS, {
      formValues: STATE.FORM_VALUES,
      startedFillingForm: STATE.STARTED_FILLING_FORM
    }),
    ...mapState(STATE.SCOPE_OFFICIALS, {
      candidates: STATE.CANDIDATE_PREVIEWS,
      legislators: STATE.ELECTED_OFFICIAL_PREVIEWS
    })
  },
  watch: {
    // `action` event
    hasAdvocate(hasAdvocate) {
      if (hasAdvocate) {
        dispatch("action", this.advocateRecord);
      }
    },
    // `candidatesFetched` event
    candidates(data) {
      if (!_isEmpty(data)) {
        dispatch("candidatesFetched", data);
      }
    },
    // `formError` event
    formError(error) {
      if (error.length > 0) {
        dispatch("formError", error);
      }
    },
    // `formStart` event
    startedFillingForm() {
      dispatch("formStart");
    },
    // `formValid` event
    formValid(valid) {
      if (valid) {
        dispatch("formValid", this.formValues);
      }
    },
    // `legislatorsFetched` event
    legislators(data) {
      if (!_isEmpty(data)) {
        dispatch("legislatorsFetched", data);
      }
    },
    // `paperRegistrationComplete` event
    registrationCompleted(value) {
      if (value) {
        dispatch("paperRegistrationComplete");
      }
    },
    // `routeChange` event
    $route(route) {
      dispatch("routeChange", route);
    },
    // `voterInfoFetched` event
    voterInformation(info) {
      if (!_isEmpty(info.registrationStatus)) {
        dispatch("voterInfoFetched", {
          ...info,
          registered: info.registrationStatus.registered
        });
      }
    }
  }
};